export default {
    spinner: false,
    pagination: {},
    paginationScreen: "",
    successMessage: false,
    successMessageLable: ''
}